<mat-form-field class="full one-user-select" appearance="outline" >
    <mat-label>{{label}}</mat-label>
    <mat-chip-list #chipList aria-label="Chon ng xet duyet">
        <mat-chip class="user-chip" *ngFor="let user of selectedUsers" [selectable]="selectable" [removable]="!isFixed(user)"
            (removed)="remove(user)">
            <div class="one-mat-selected">
              <div class="option-avatar">
                <one-avatar size="30" [imageUrl]="user.avatarUrl"></one-avatar>
              </div>
              <div class="option-info">
                <span class="option-info-text">{{ user.fullName }}</span>
              </div>
            </div>
            <mat-icon matChipRemove *ngIf="!isFixed(user) && !isDisabled">cancel</mat-icon>
        </mat-chip>
        <input *ngIf="!isDisabled" placeholder="Tìm kiếm" #userInput [formControl]="userCtrl" [matAutocomplete]="auto"
            [matChipInputFor]="chipList" [readonly]="isDisabled">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
          <div class="one-mat-option-select">
            <div class="option-avatar">
              <one-avatar size="30" [imageUrl]="user.avatarUrl"></one-avatar>
            </div>
            <div class="option-info">
              <span class="option-info-text">{{ user.fullName }}</span>
            </div>
          </div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
